// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__FBhFN","logotype":"logo_logotype__EwH-0"};